import { useRef, useState } from "react"
import { hideLoader, showLoader } from '../../components/loader';
import { toast } from 'react-toastify';
import { Alert } from "react-bootstrap";
import { apiUrl } from "../../utils/url";
import { useEffect } from "react";
import * as $ from "jquery";
import productType from "../../assets/img/product-type-icon.svg";
import ErrorMessage from "../errors/errorMessage";
import FormFieldError from "../errors/formFieldError";
import SelectedThemeInput from "../custom-theme/commons/select-theme-input";
import SelectedCustomTheme from "../custom-theme/commons/select-custom-theme";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

function CampaignStep({moveNext}) {
    const [error, setError] = useState([])
    const { basePath, slug } = useSelector((state) => state?.slugReducer);
    const [value, setValue] = useState({
        title: null, short_description: null, product_slug: null, product_theme: "darkmode", accent_theme: "#5D5DFF", logo: null, company_name: null, button_url: null,
    })
    const history  = useHistory();
    const fileupload = useRef(null);
    const handleChange = (e) => {
        if (e.target.name == 'title') {
            let slug = e.target.value.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi, '-');
            slug = slug.replaceAll(' ', '-');
            setValue({ ...value, product_slug: slug });
        }
        setValue({ ...value, [e.target.name]: e.target.value });
    };
    async function handleSave(e) {
        e.preventDefault();
        showLoader();
        setError({});

        const api = apiUrl + "/ProductFlow/createProduct";
        const formdata = new FormData();
        for (const key in value) {
            if (Object.hasOwnProperty.call(value, key)) {
                formdata.append(key, value[key]);
            }
        }
        formdata.append("project", slug ? slug : localStorage.slug);
        formdata.append("step", 2);
        
        const myHeaders = new Headers();
        myHeaders.append(
            "Authorization",
            `Bearer ${localStorage?.getItem("token")}`
        );
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders,
        };
        fetch(api, setOptions)
            .then(async (res) => {
                const response = await res?.json();
                if (response?.status_code == 200) {
                    localStorage.removeItem("lastStep")
                    localStorage.removeItem("currentStep")
                    localStorage.removeItem("walkthrough_step")
                    localStorage.setItem("walkthrough", 1)

                    history.push({
                        pathname: "/project/" + (slug ? slug  : localStorage?.slug) + "/editCampaign",
                        state: {
                            edit: { is: true, id: response?.id },
                            product_id: response?.data?.product_id,
                            fron: null,
                            sidebarOpen: true,
                            welcomeModalOpen: true
                        }
                    });
                    history.go()
                    hideLoader();
                    toast.success(`Campaign Created Successfully `)
                } else {
                    setError(Object.values(response?.errors));
                    if (Object.keys(response?.errors).length > 0)
                        $(".modal-body").scrollTop(0);
                    hideLoader();
                }
            })
            .catch(() => {
                hideLoader();
            });
    }
    const onfilechange = (e) => {
        const fileList = e.target.files[0];
        var reader = new FileReader();

        reader.onload = function (event) {
            setValue({...value,logo:event.target.result});
        };
        reader.readAsDataURL(fileList);
    }
    const themeChange = () => { 
        $('.color-picker-modal').removeClass("d-none");  
        $('.color-picker-main').removeClass("d-none");   
        $('.color-picker-modal').addClass("d-flex");
        $('.color-picker-main').addClass("d-flex");
    };
    const colorChange = (color) => {
        setValue({...value,accent_theme:color})
    }
    return (
        <div id="wrapper">
            <div class="auth-main background-area main-u">
                <div class="steps-card">
                    <div class="card border-0 p-0 m-0 w-100 h-100">
                        <div >
                            <h1 class="text-left newpageheading mb-0">Let’s build your campaign</h1>
                            <form className="margin-top-38" method="post" role="form" onSubmit={(e) => { handleSave(e) }}>
                                {error?.length > 0 && (
                                    <Alert variant="danger">
                                        {error?.map((val, index) => <li>{val}</li>)}
                                    </Alert>
                                )}
                                <div>
                                    <div className="form-group mt-20px">
                                        <label className="productlabels">
                                            Campaign Title
                                            <small className="text-red">*</small>
                                        </label>
                                        <input
                                            value={value?.title}
                                            onChange={handleChange}
                                            type="text"
                                            className="zaapGlobal-input"
                                            name="title"
                                            placeholder="eg: May SaaS Leads"
                                        />
                                        <FormFieldError error={error?.title} />
                                    </div>
                                    <div class="form-group mt-20px">
                                        <div className="d-flex align-items-center py-1">
                                            <label class="text-gray font-14-u">Company Logo</label>
                                        </div>
                                        <div class="mb-3 d-flex ps-0 zaap-border-rounded pt-2" style={{ borderColor: '#E8E9EA', gap: "7px" }}>
                                            {value?.logo ? <img className="dropzone-wrapper dropzone-wrapper5 fav-uplod" src={value?.logo} /> : null}
                                            <div className="d-flex justify-content-end uplod-btn-u">
                                                <input id="file-upload" type="file" ref={fileupload} className="d-none" accept=".png,.jpg,.jpeg" name="logo" onChange={onfilechange} />
                                                <button type="button" onClick={() => fileupload.current.click()} class="btn btn-semi-rounded d-flex align-items-center justify-content-center">
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z" fill="#333333" />
                                                    </svg>
                                                    <span class="upload-text">Upload New</span>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-group mt-20px">
                                        <label className="productlabels">
                                            Company Name
                                            <small className="text-red">*</small>
                                        </label>
                                        <input
                                            value={value?.company_name}
                                            onChange={handleChange}
                                            type="text"
                                            className="zaapGlobal-input"
                                            name="company_name"
                                            placeholder="Your Company"
                                        />
                                        <FormFieldError error={error?.title} />
                                    </div>
                                    <div className="form-group mt-20px">
                                        <label className="productlabels">
                                            Product/Service Description
                                            <small className="text-red">*</small>
                                        </label>
                                        <input
                                            value={value?.short_description}
                                            onChange={handleChange}
                                            type="text"
                                            className="zaapGlobal-input"
                                            name="short_description"
                                            placeholder="eg: We make custom videos to grow your organic reach"
                                        />
                                    </div>
                                    <div className="form-group mt-20px">
                                        <div className="col-6 pl-0 d-flex align-items-center" id="header-theme">
                                            <span className="zaap-normal-text">Brand Color</span>
                                        </div>

                                        <SelectedThemeInput data_type={"brand_color"} themeType="brand_color" color={value?.accent_theme} themeChange={themeChange} />
                                        <SelectedCustomTheme nthChild="" themeType="brand_color" color={value?.accent_theme} from={'campaigns'} colorChange={colorChange} />
                                    </div>
                                </div>
                                <div class="form-group mt-20px">
                                <button type="submit" name="submit"  class="red-btn-u">
                                    Continue 
                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="9" height="8" viewBox="0 0 9 8" fill="none"><path d="M2.85366 8C3.12287 8 3.30511 7.80467 3.30511 7.53715C3.30511 7.39703 3.25127 7.29512 3.16843 7.21019L2.11643 6.15711L1.39162 5.53291L2.34837 5.57537H7.51726C8.55683 5.57537 9 5.09554 9 4.04246V1.52442C9 0.458599 8.55683 0 7.51726 0H5.21859C4.9411 0 4.74643 0.212314 4.74643 0.475584C4.74643 0.734607 4.9411 0.946921 5.21445 0.946921H7.49655C7.91072 0.946921 8.08882 1.12951 8.08882 1.55414V4.01274C8.08882 4.45011 7.91072 4.62845 7.49655 4.62845H2.34837L1.39162 4.67516L2.11643 4.04671L3.16843 2.99788C3.25127 2.91295 3.30511 2.80679 3.30511 2.66667C3.30511 2.4034 3.12287 2.20807 2.85366 2.20807C2.73769 2.20807 2.6093 2.26327 2.51818 2.35669L0.144961 4.75159C0.0497009 4.84501 0 4.9724 0 5.10403C0 5.23142 0.0497009 5.35881 0.144961 5.45223L2.51818 7.85138C2.6093 7.9448 2.73769 8 2.85366 8Z" fill="white"/></svg></span>
                                </button> 
                            </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CampaignStep